import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild, HostListener } from '@angular/core';
import { Router } from '@angular/router';
// import { StateService } from '@uirouter/angular';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

import { AuthService } from './../../services/auth.service';
import { UserService } from './../../services/user.service';
import { AppinfoService } from './../../services/appinfo.service';
import { AzgivService } from './../../services/azgiv.service';
import { CancelTranscService } from './../../services/cancel-transc.service';
import { IdleService } from './../../services/idle.service';
import { ContentJobsService } from './../content-jobs/content-jobs.service';
import { LayerQcService } from './../../services/layer-qc.service';
import { SocketService, SocketMessageFE, ProcessType, SocketLog, PrintJsonMessage } from './../../services/socket.service';
import { SocketProcess, CommonSocketMsgComponent } from './../common-socket-msg/common-socket-msg.component';
import { IntegratorService } from 'app/services/integrator.service';
import { SocketSidekickService } from 'app/services/socket-sidekick.service';
import { CommonModalService } from 'app/services/common-modal.service';
import { SocketErrorsModalData, SocketErrorsModalComponent } from '../modal/socket-errors-modal/socket-errors-modal.component';
import { LayerService } from 'app/services/layer.service';
import { EnablePublishLayerService } from 'app/services/enable-publish-layer.service';
import { TransactionLogService } from 'app/services/transaction-log.service';
import { LongTransaction } from 'app/components/feat-transaction-log/feat-transaction-log.component';
import { DomainService } from 'app/services/domain.service';
import { InterlayerReportService } from 'app/services/interlayer-report.service';
import { ClearService } from 'app/services/clear.service';
import { FishboneService } from 'app/services/fishbone.service';

@Component({
	selector: 'app-azgiv',
	templateUrl: './azgiv.component.html',
	styleUrls: ['./azgiv.component.css']
})
export class AzgivComponent implements OnInit, OnDestroy, AfterViewInit {

	test;
	// @ViewChild('socketMsgPane') socketPane: CommonSocketMsgComponent;

	// Show / hide Control Pane
	public isControlPane = true;
	public isControlPaneSub: Subscription;

	// Is socket message window closed
	public isSocketMsgClosed = true;
	// Socket processes to display in common-socket-msg component
	public socketProcesses: SocketProcess[] = []; // { id: 'test', type: 'test', status: 'Preparing', messages: ['test'], endTime: null }
	// Functions of process types
	public funcsByProcessType: {
		'Upload': { viewLogs: Function; viewData: Function, cancel: Function},
		'QC': {viewLogs: Function; viewData: Function, cancel: Function},
		'BuildingTopo': {viewLogs: Function; viewData: Function, cancel: Function}
	};

	// Subscribe to idle status change
	private idleStatusSub: Subscription;
	// Subscribe to init socket process
	private initProcessSub: Subscription;
	// Subscribe to file-uploading socket messages
	private filePostSub: Subscription;
	private uploadingFinishSub: Subscription;
	// Subscribe to qc socket messages
	private qcSocketSub: Subscription;
	private qrSocketSub: Subscription;
	private fbSocketSub: Subscription;
	// Subscribe to buildTopo socket message
	private buildTopoSocketSub: Subscription;
	//
	private selectedCustomerSub: Subscription;
	// // Subscribe to browser window resize end
	// private windowResizeEndSub: Subscription;
	// // Subscribe to idle status change
	// public idleStatusSub: Subscription;
	private layerListBSSub: Subscription;

	constructor(
		private router: Router,
		// private stateService: StateService,
		private toastr: ToastrService,
		private authService: AuthService,
		private integratorService: IntegratorService,
		private userService: UserService,
		private appinfoService: AppinfoService,
		private azgivService: AzgivService,
		private cancelService: CancelTranscService,
		private clearService: ClearService,
		private domainService: DomainService,
		private fishboneService: FishboneService,
		private idleService: IdleService,
		private jobsService: ContentJobsService,
		private layerService: LayerService,
		private qcService: LayerQcService,
		private reportService: InterlayerReportService,
		private modalService: CommonModalService,
		private socketService: SocketService,
		private socketSidekickService: SocketSidekickService,
		private enablePublishLayerService: EnablePublishLayerService,
		private transactionLogService: TransactionLogService
	) { }

	@HostListener('window:beforeunload', ['$event'])
	onWindowUnload() {
		// this.socketSidekickService.sendMessage('close');
		this.socketSidekickService.disconnectSocket();
		debugger
	}

	onPaneResizeEnd() {
		this.azgivService.controlPaneResizeEnd.next(null);
	}

	// Add / update a socket process in socketProcesses
	private addSocketProcess(data: SocketMessageFE, type: ProcessType, isPreparing?: boolean) {
		// this.socketPane.show();
		// Find process by processId
		let process = this.socketProcesses.find((p) => p.id === data.processId);
		let transaction: LongTransaction = this.transactionLogService.socketProcesses.value.find((t) => t.id === data.processId);
		// Init a new process if process doesn't exist
		if (!process) {
			process = {
				id: data.processId,
				type: type === 'TOPO' ? 'BuildingTopo' : type,
				status: isPreparing ? 'Preparing' : 'Processing',
				messages: [],
				info: data.info || {}
			};
			this.socketProcesses.unshift(process);
			// NOTE: Do not return here.
				// In case the user logs out then logs back in, when the final message is passed, it will be processed as 'Processing' if return here.

			// return;
		}
		if (!transaction) {
			transaction = {
				id: data.processId,
				type: type === 'TOPO' ? 'BuildingTopo' : type,
				status: isPreparing ? 'Preparing' : 'Processing',
				messages: [],
				info: data.info || {},
				hideMessage: false
			};
		}
		// Update the process messages, status, timestamp, etc
		if (data.isFinal) {
			if (data.isError) { // Error
				const message = data.data.errorMessage + '' + data.data.errorDetail;
				process.messages.push(message);
				transaction.messages.push({
					message: message,
					time: data.timeStamp,
					type: 'err'
				});
				process.status = 'Error';
				transaction.status = 'Error';
			} else if (data.isCanceled) { // Cancel
				process.status = 'Canceled';
				transaction.status = 'Canceled';
			} else { // Success
				process.status = 'Completed';
				transaction.status = 'Completed';
			}
			// Add Timestamp
			process.endTime = data.timeStamp;
			transaction.endTime = data.timeStamp;
		} else {
			// Change the process status only if:
			// 1. Process's not finished (finish includes: Completed, Error, and Canceled)
			// 2. Or process is being canceld
			switch (process.status) {
				case 'Preparing': // The first message

				case 'Completed':
				case 'Error':
				case 'Canceled':
				case 'Canceling':
					break;
				default:
					{
						process.status = 'Processing';
						transaction.status = 'Processing';
					}
					
			}
			// if (process.status !== 'Completed' && process.status !== 'Error' && process.status !== 'Canceled') {
			// 	process.status = 'Processing';
			// 	// TODO
			// 	// // process.status = 'Uploading';
			// 	// switch (process.type) {
			// 	// 	case 'Upload':
			// 	// 		process.status = 'Uploading';
			// 	// 		break;
			// 	// 	case 'QC':
			// 	// 		process.status = 'QCing';
			// 	// }
			// }
			if (data.dataType === 'print') {
				process.messages.push(data.data);
				transaction.messages.push({
					type: 'info',
					message: data.data,
					time: data.timeStamp
				})
			} else if (data.dataType === 'printJson') {
				Object.keys(data.data).forEach((key) => {
					data.data[key].forEach((item) => {
						transaction.messages.push({
							message: item.print,
							time: item.time,
							type: item.typ
						})
					})
				})
			}
		}
		const filtered = this.transactionLogService.socketProcesses.value.filter((t) => t.id !== transaction.id)
		filtered.unshift(transaction);
		this.transactionLogService.socketProcesses.next(filtered);
	}
	private cancelProcess(processId) {
		const process = this.socketProcesses.find((p) => p.id === processId);
		// Cancel the process
		this.cancelService.cancelTransc(processId, () => {
			// Update process type as canceling
			// This should be set after cancelTransc is successfully called.
			if (process.status !== 'Completed' || 'Error') { // if process already finished, do not update status
				process.status = 'Canceling';
			}
		});
	}

	private getPrintJsonErrors(log: SocketLog) {
		const errorsMessages: PrintJsonMessage[] = [];
		if (!log.socketMsg) { return errorsMessages };
		log.socketMsg.forEach(i => {
			if (i.dataType === 'printJson') {
				if (!i.data) { return; }
				Object.keys(i.data).forEach(cate => {
					i.data[cate].forEach(m => {
						if (m.typ === 'err') {
							errorsMessages.push(m);
						}
					})
				})
			}
		})
		return errorsMessages;
	}
	private showPrintJsonErrors(messages: {upload?: PrintJsonMessage[]; qc?: PrintJsonMessage[];}, processType: 'Upload' | 'QC' | 'UploadWithQC') {
		if (messages && ((messages.qc && messages.qc.length) || (messages.upload && messages.upload.length))) {
			const modalData: SocketErrorsModalData = {
				processType: processType,
				messages: messages
			};
			this.modalService.openModalWindow(SocketErrorsModalComponent, {
				data: modalData
			});
		}
	}
	async ngOnInit() {
		// Generate uuid
		this.appinfoService.generateSessionUuid();

		this.socketService.connectSocket();
		//
		if (this.socketSidekickService.socketParam) {
			this.socketSidekickService.connect();
		}

		this.isControlPaneSub = this.azgivService.isControlPane.subscribe((value: boolean) => {
			this.isControlPane = value;
		});

		this.initProcessSub = this.socketService.onInitProcess.subscribe((data) => {
			if (!data.processId) {
				this.addSocketProcess({
					processId: data.tempId,
					processType: data.processType,
					isFinal: false,
					isError: false,
					isCanceled: false,
					dataType: 'print',
					data: '',
					timeStamp: null
				}, data.processType, true);
			} else {
				// Update tempId to real processId in socketProcesses
				const process = this.socketProcesses.find((p) => p.id === data.tempId);
				process.id = data.processId;
				// Update process status
				process.status = data.status;
				//
				const socketProcesses = this.transactionLogService.socketProcesses.getValue();
				const socketProcess = socketProcesses.find(i => i.id === data.tempId);
				socketProcess.id = data.processId;
				this.transactionLogService.socketProcesses.next(socketProcesses);
			}
		});
		this.filePostSub = this.socketService.filePostSubject.subscribe(async (data: SocketMessageFE) => {
			// Update socketProcesses
			this.addSocketProcess(data, 'Upload');
			// Update socketLogs
			this.socketService.onSocketUpdate(data, this.jobsService.uploadingLogs, {
				success: 'File uploaded.',
				canceled: 'Uploading process canceld by user.'
			});
			if (data.isFinal === true) {
				let customerId;
				if (!data.isError && !data.isCanceled) {
					customerId = data.data.misc ? data.data.misc.customerId : null;
						// const uploadWithQc = this.jobsService.uploadWithQcProcesses[data.processId];
						// if (uploadWithQc) {
						// 	const layerIds = data.data.misc.layers || [];
						// 	layerIds.forEach(async layerId => {
						// 		const qc = await this.qcService.qcLayers(layerId);
						// 		// TODO: currently only last qcProcessId will be saved
						// 		uploadWithQc.qcProcessId = qc.processId;
						// 	})
						// } else 
					// {
						// Open socket errors modal if process is successfully done but there's error messages during it
						const logs = this.jobsService.uploadingLogs.getValue();
						const log = logs[data.processId];
						const messages = this.getPrintJsonErrors(log);
						this.showPrintJsonErrors({
							upload: messages
						}, 'Upload');
					// }
				}
				console.log('111111111111, onFinish')
				this.jobsService.onUploadingFinish.next({isError: data.isError, customerId: customerId});
			}
		});
		this.uploadingFinishSub = this.jobsService.onUploadingFinish.subscribe(async (data) => {
			console.log('onUploadingFinish', data)
			if (data && !data.isError) {
				console.log('22222222222222')
				await this.layerService.getLayers();
			}
		});
		this.qcSocketSub = this.socketService.qcSocketSubject.subscribe(async (data: SocketMessageFE) => {
			// Update socketProcesses
			this.addSocketProcess(data, 'QC');
			// Update socketLogs
			this.socketService.onSocketUpdate(data, this.qcService.qcLogs, {
				success: 'QC Completed.',
				canceled: 'QC process canceled by user.'
			});
			if (data.isFinal === true ) {
				let customerId;
				if (!data.isError && !data.isCanceled) {
					customerId = data.data.misc ? data.data.misc.customerId : null;
					// // Open socket errors modal if process is successfully done but there's error messages during it
					
					// const uploadProcessId = Object.keys(this.jobsService.uploadWithQcProcesses).find(id => {
					// 	return this.jobsService.uploadWithQcProcesses[id].qcProcessId === data.processId;
					// });
					const qcLogs = this.qcService.qcLogs.getValue();
					const qcLog = qcLogs[data.processId];
					const qcMessages = this.getPrintJsonErrors(qcLog);
					// if (uploadProcessId) {
					// 	const logs = this.jobsService.uploadingLogs.getValue();
					// 	const log = logs[uploadProcessId];
					// 	const messages = this.getPrintJsonErrors(log);
					// 	this.showPrintJsonErrors({
					// 		upload: messages,
					// 		qc: qcMessages
					// 	}, 'UploadWithQC');
					// } else {
						this.showPrintJsonErrors({
							qc: qcMessages
						}, 'QC');
					// }
				}
				this.qcService.onQcFinish.next({isError: data.isError, customerId: customerId});
			}
		});
		this.qrSocketSub = this.socketService.qrSocketSubject.subscribe(async (data: SocketMessageFE) => {
			// Update socketProcesses
			this.addSocketProcess(data, 'QR');
			// Update socketLogs
			this.socketService.onSocketUpdate(data, this.reportService.qrLogs, {
				success: 'QR Completed.',
				canceled: 'QR process canceled by user.'
			});
			if (data.isFinal === true ) {
				if (!data.isError && !data.isCanceled) {
					const qrLogs = this.reportService.qrLogs.getValue();
					const qrLog = qrLogs[data.processId];
					const qrMessages = this.getPrintJsonErrors(qrLog);
					this.showPrintJsonErrors({
						qc: qrMessages
					}, 'QC');
				}
				this.reportService.onQrFinish.next({isError: data.isError});
			}
		});
		this.fbSocketSub = this.socketService.fishboneSubject.subscribe(async (data: SocketMessageFE) => {
			// Update socketProcesses
			this.addSocketProcess(data, 'AnalyzeFishbone');
			// Update socketLogs
			this.socketService.onSocketUpdate(data, this.reportService.qrLogs, {
				success: 'Fishbone Completed.',
				canceled: 'Fishbone process canceled by user.'
			});
			if (data.isFinal === true ) {
				if (!data.isError && !data.isCanceled) {
					const fbLogs = this.fishboneService.fbLogs.getValue();
					const fbLog = fbLogs[data.processId];
					const qrMessages = this.getPrintJsonErrors(fbLog);
					this.showPrintJsonErrors({
						qc: qrMessages
					}, 'QC');
				}
				this.fishboneService.onFbFinish.next({isError: data.isError});
			}
		});
		this.buildTopoSocketSub = this.socketService.buildTopoSubject.subscribe((data) => {
			this.addSocketProcess(data, 'TOPO');
			this.socketService.onSocketUpdate(data, this.qcService.topoLogs, {
				success: 'Buliding Topology completed.',
				canceled: 'Buliding Topology process canceld by user.'
			});
		});

		this.funcsByProcessType = {
			Upload: {
				viewLogs: (processId) => {
					// this.stateService.go('jobsuploadlogs', {
					// 	processId: processId
					// });
					this.router.navigate(['azgiv/jobs/upload-logs', { processId: processId }]);
				},
				viewData: () => {
					// this.stateService.go('jobsfilesreview');
					this.router.navigate(['azgiv/review/data-view']);
				},
				cancel: (processId) => {
					this.cancelProcess(processId);
				}
			},
			QC: {
				viewLogs: (processId) => {
					// this.stateService.go('jobsqclogs', {
					// 	processId: processId
					// });
					this.router.navigate(['azgiv/jobs/qc-logs', { processId: processId }]);
				},
				viewData: () => {},
				cancel: (processId) => {
					this.cancelProcess(processId);
				}
			},
			BuildingTopo: {
				viewLogs: (processId) => {
					this.router.navigate(['azgiv/jobs/topo-logs', { processId: processId }]);
				},
				viewData: () => {},
				cancel: (processId) => {
					this.cancelProcess(processId);
				}

			}
		};

		// Set idle
		this.idleService.initIdleMonitor();
		// Subscribe to user idle status change
		this.idleStatusSub = this.idleService.status.subscribe((status) => {
			switch (status) {
				case 'active':
					this.idleService.setActive();
					break;
				case 'timeout':
					this.idleService.clearActiveTimeout();
					this.clearService.logout();
					break;
				case 'idling':
					this.authService.updateToken();
					this.authService.clearTokenUpdateInterval();
					this.idleService.clearActiveTimeout();
					this.idleService.openIdleWindow((result) => {
						switch (result) {
							case 'stay':
								this.authService.setTokenUpdateInterval();
								this.authService.updateToken();
								this.idleService.status.next('active');
								break;
							default:
								this.clearService.logout();
						}
					});
			}
		});

		// Set token to renew every xxx minute.
		this.authService.updateToken();
		this.authService.setTokenUpdateInterval();

		// Store selectedCustomer to local storage
		this.selectedCustomerSub = this.userService.selectedCustomer.subscribe(async (i) => {
			if (i) {
				// Update domain
				console.log('xxxxxxxxx')
				await this.domainService.getDomains();

				localStorage.setItem(this.userService.selectedCustomerItemName, JSON.stringify(i));
			}
		});

		this.layerListBSSub = this.layerService.layerListBS.subscribe(data => {
			if (data.publishedLayers.length > 0) {
				this.enablePublishLayerService.setValue(true);
			} else {
				this.enablePublishLayerService.setValue(false);
			}
		});
		
	}
	ngAfterViewInit() {
	}
	ngOnDestroy() {
		this.idleStatusSub.unsubscribe();
		this.isControlPaneSub.unsubscribe();
		this.initProcessSub.unsubscribe();
		this.filePostSub.unsubscribe();
		this.uploadingFinishSub.unsubscribe();
		this.qcSocketSub.unsubscribe();
		this.qrSocketSub.unsubscribe();
		this.fbSocketSub.unsubscribe();
		this.buildTopoSocketSub.unsubscribe();

		this.selectedCustomerSub.unsubscribe();
	}
}
